export const CONTENT_SAVE_STATES = {
  SAVING: 'saving',
  JUST_SAVED: 'just-saved',
  SAVED: 'saved',
  UNSAVED: 'unsaved',
  REMOVING: 'removing',
}
